import Link from 'next/link';
import ArrowRight from '../../../../../public/svg/arrow-right.svg';
import { cn } from '@shared/shared-utils';
import { AppRoute } from '../../../../libs/enums/enums';

type Properties = {
  to: string;
  caption: string;
  className?: string;
  captionClassName?: string;
  target?: '_blank' | '_self';
};

const RoundedBorder = ({
  to = AppRoute.FIND_A_PROFESSIONAL,
  caption,
  className,
  captionClassName,
  target = '_self',
}: Properties) => {
  return (
    <Link
      href={to}
      target={target}
      className={cn(
        'flex border-[6px] border-ogn-blue rounded-[16px]',
        className,
      )}
    >
      <div
        className={cn(
          'text-ogn-blue text-[20px] py-5 pl-8 pr-6 lg:px-10 w-full font-roboto-condensed',
          captionClassName,
        )}
      >
        {caption}
      </div>
      <div className="w-[36px] lg:w-[62px] min-h-full bg-ogn-blue shrink-0 flex items-center justify-center">
        <ArrowRight className="w-[28px] lg:w-[42px] h-[20px] lg:h-[28px] text-ogn-bright-yellow" />
      </div>
    </Link>
  );
};

export { RoundedBorder };
